"use client";

import { signIn } from "next-auth/react";
import { signOut } from "next-auth/react";

import type { LoginFormValues } from "./schemas";

type SignInResult = {
  error?: string;
  ok?: boolean;
  status?: number;
  url?: string | null;
};

export async function login(
  input: LoginFormValues,
): Promise<SignInResult | undefined> {
  return (await signIn("credentials", {
    redirect: false,
    email: input.email,
    password: input.password,
  })) as SignInResult | undefined;
}

export async function logout() {
  await signOut({
    redirect: true,
    callbackUrl: "/login",
  });
}